import { FormField, Input } from '@amzn/awsui-components-console';
import React, { useEffect, useState } from 'react';

/**
 * A form field component of input with validation
 * @param {*} props
 * @returns
 */
export default function InputWithValidation(props) {
    return (
        <FormField label={props.label} description={props.description} errorText={props.errorText}>
            <Input
                placeholder={props.placeholder}
                value={props.value}
                type={props.type}
                onChange={(event) => {
                    props.setValue(event.detail.value);
                    props.setError('');
                }}
            />
        </FormField>
    );
}
